import { useRef } from "react";

import PieChartMini from "./defaulViewPieChartMini";
import PieChart from "./defaulViewPieChart";
import { InterfaceGraph } from "../interfaces/InterfaceGraph";




 const MainCP: React.FC<InterfaceGraph> = (props) => {
    const divRef = useRef(null);

    const { idTipoGraficoProps,nameTitleProps,tituloProps='',subtitleProps='',selectValueProsp=[],formatDataStringData='%',disableFilterProps=true,numDecimalProps=0,pieTextProps='',showPieTextInGraph=true,showLineTop=true,showSeries=true,enableMiniBox=false} = props;

    return (
      
        <>
        {
            enableMiniBox
            ?<PieChartMini {...props} />
            :<PieChart {...props}/>
        }
        </>
    )
  }
  
 

  export default MainCP;
  